import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
  BANK_CREATE, BANK_LIST, COMPANY_BANK_LIST, BANK_SINGLE, BANK_UPDATE, BANK_DELETE, CLEAR_BANK_TEMP_STATES, CLEAR_BANK_STATES,
} from '../../../Helper/actionsTypes';
// documantation 5 bank data is going to store here
const bankReducer = (state = [], action) => {
  switch (action.type) {

    case BANK_LIST: {
      return action.payload.code === 200
        ? { ...state, list: action.payload.results }
        : { ...state, list: [] };
    }
    case COMPANY_BANK_LIST: {
      return action.payload.code === 200
        ? { ...state, list: action.payload.results }
        : { ...state, list: [] }
    }

    case BANK_SINGLE: {
      if (action.payload.code === 200) return { ...state, single: action.payload.results[0] }
      else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else return { ...state, single: action.error };
    }

    case BANK_DELETE: {
      if (action.payload.code === 200) return { ...state, itemDeleted: true, message: action.payload.message }
      else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else if (action.payload.code === 500) return { ...state, itemDeleted: false, message: DELMSG }
      else return { ...state, itemDeleted: false, message: action.payload.message }
    }

    case BANK_CREATE: {
      if (action.payload.code === 200) return { ...state, itemSaved: true, message: action.payload.message }
      else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else if (action.payload.code === 500) return { ...state, itemSaved: false, message: CRTMSG }
      else return { ...state, itemSaved: false, message: action.payload.message }
    }

    case BANK_UPDATE: {
      if (action.payload.code === 200) return { ...state, itemUpdated: true, message: action.payload.message }
      else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else if (action.payload.code === 500) return { ...state, itemUpdated: false, message: UPTMSG }
      else return { ...state, itemUpdated: false, message: action.payload.message }
    }
    
    case CLEAR_BANK_TEMP_STATES: return { ...state, itemDeleted: null, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, message: null, badReq:null };
    case CLEAR_BANK_STATES: return {};
    default: return state;
  }
};

export default bankReducer;